import { NavbarMegaDropdown } from './../navbar/navbar-mega-dropdown';
import { Component } from '@opten/compiler/metadata/component';
import { ComponentRef, ComponentRefs } from '@opten/compiler/metadata/di';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { Navbar } from '../navbar';
import { Search, SearchDesktop } from './search';
import { isMobile } from '../../utilities/detection';


@Component({ className: 'js-search-toggler' })
export class SearchToggler implements OnInit {
    @ComponentRef(Navbar) _navbar: Navbar;
    @ComponentRefs(NavbarMegaDropdown) _dropdowns: Array<NavbarMegaDropdown>;
    @ComponentRef(Search) _search: Search;
    @ComponentRef(SearchDesktop) _searchDesktop: SearchDesktop;

    constructor(private element: HTMLElement) {}

    onInit() {
        this._search = new Search(document.getElementsByClassName('js-search')[0] as HTMLElement);
        this._searchDesktop = new SearchDesktop(document.getElementsByClassName('js-search-desktop')[0] as HTMLElement);
        this._handleResize();
        window.addEventListener('resize', () => this._handleResize());
        window.addEventListener('scroll', () => this._handleScroll());
        
        this.element.addEventListener('click', event => {
            event.preventDefault();
            if (isMobile()) {
                this._search.toggle();
            } else { 
                this._searchDesktop.toggle();
            }

            if (this._dropdowns && this._dropdowns.length) {
                this._dropdowns.forEach(dropdown => dropdown.hide());
            }
        });
    }
    private _handleResize() {
        this._search.close();
        this._searchDesktop.close();
	}

    private _handleScroll() {
        this._searchDesktop.close();
	}
}
